import React from "react";
import ReactGA from "react-ga";

export function toCurrency(number) {
  const integer = parseInt(number);
  const currency = (integer / 100).toFixed(2);
  return currency;
}

export function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

export function handleGAEvent(category, action, label) {
  ReactGA.event({
    category: category,
    action: action,
    label: label
  });
}
